import { useEffect } from 'react'
import { CheckCircle2, X, XCircle } from 'lucide-react'

export interface ToastState { type: 'success' | 'error'; message: string }

export function Toast({ toast, onClose }: { toast: ToastState | null; onClose: () => void }) {
  useEffect(() => {
    if (toast?.type !== 'success') return
    const timeout = window.setTimeout(onClose, 3000)
    return () => window.clearTimeout(timeout)
  }, [toast])

  if (!toast) return null
  return (
    <div className={`toast ${toast.type}`} role="status">
      {toast.type === 'success' ? <CheckCircle2 size={20} /> : <XCircle size={20} />}
      <span>{toast.message}</span>
      <button className="icon-button" onClick={onClose} aria-label="Fechar"><X size={17} /></button>
    </div>
  )
}
